import { clsx } from 'clsx'
import { useTranslation } from 'react-i18next'

interface Props {
  value: number | null | undefined
  onChange: (score: number) => void
  disabled?: boolean
}

const SCORES = [
  {
    score: 1,
    activeClass: 'bg-lc-red-900 text-white shadow-[0_2px_0_0_var(--color-lc-red-dark)]',
    hoverClass: 'hover:bg-lc-red-100 hover:text-lc-red-dark',
  },
  {
    score: 2,
    activeClass: 'bg-lc-orange-900 text-white shadow-[0_2px_0_0_var(--color-lc-orange-dark)]',
    hoverClass: 'hover:bg-lc-orange-100 hover:text-lc-orange-dark',
  },
  {
    score: 3,
    activeClass: 'bg-lc-green-900 text-white shadow-[0_2px_0_0_var(--color-lc-green-dark)]',
    hoverClass: 'hover:bg-lc-green-100 hover:text-lc-green-dark',
  },
  {
    score: 4,
    activeClass: 'bg-lc-mint-900 text-white shadow-[0_2px_0_0_var(--color-lc-mint-dark)]',
    hoverClass: 'hover:bg-lc-mint-100 hover:text-lc-mint-dark',
  },
  {
    score: 5,
    activeClass: 'bg-lc-lightblue-900 text-white shadow-[0_2px_0_0_var(--color-lc-lightblue-dark)]',
    hoverClass: 'hover:bg-lc-lightblue-100 hover:text-lc-lightblue-dark',
  },
] as const

/**
 * 핵심 체크 5점 척도 입력 (Phase 6a, §5-13=A) — BuildupStepGradeToggle 미러.
 * 1:1 코칭 후 교사가 입력하는 원생 최종 이해도(1 낮음 ~ 5 높음).
 */
export function EssentialCheckRatingInput({ value, onChange, disabled }: Props) {
  const { t } = useTranslation('coaching')
  return (
    <div
      data-testid="essential-check-rating"
      role="group"
      aria-label={t('coachingGuide.essentialCheck.ratingAria')}
      className="grid w-full grid-cols-5 gap-1 rounded-lg border border-gray-200 bg-gray-100 p-1"
    >
      {SCORES.map(({ score, activeClass, hoverClass }) => (
        <button
          key={score}
          type="button"
          data-testid={`rating-${score}`}
          disabled={disabled}
          aria-pressed={value === score}
          aria-label={t('coachingGuide.essentialCheck.ratingValue', { score })}
          title={t('coachingGuide.essentialCheck.ratingValue', { score })}
          onClick={() => onChange(score)}
          className={clsx(
            'inline-flex min-h-12 items-center justify-center rounded-md px-3 py-2 text-sm font-semibold leading-none transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-900 focus-visible:ring-offset-1',
            value === score
              ? activeClass
              : ['bg-white text-gray-700', hoverClass],
            disabled && 'cursor-not-allowed opacity-50',
          )}
        >
          {score}
        </button>
      ))}
    </div>
  )
}
